<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iHcRBt/tc-custom/9780830853953.jpg?1696374800979" alt="This image is the cover for the book Brown Church"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brown Church
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong> <em>Foreword</em> INDIES Book of the Year Finalist</strong> </p> <p> <strong>Interest in and awareness of the demand for social justice as an outworking of the Christian faith is growing. But it is not new.</strong> </p> <p>For five hundred years, Latina/o culture and identity have been shaped by their challenges to the religious, socio-economic, and political status quo, whether in opposition to Spanish colonialism, Latin American dictatorships, US imperialism in Central America, the oppression of farmworkers, or the current exploitation of undocumented immigrants. Christianity has played a significant role in that movement at every stage.</p> <p>Robert Chao Romero, the son of a Mexican father and a Chinese immigrant mother, explores the history and theology of what he terms the "Brown Church." Romero considers how this movement has responded to these and other injustices throughout its history by appealing to the belief that God's vision for redemption includes not only heavenly promises but also the transformation of every aspect of our lives and the world. Walking through this history of activism and faith, readers will discover that Latina/o Christians have a heart after God's own.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Chao Romero
      </h2>
      
      <p class="authorDescription body article"><p>Robert Chao Romero (PhD, University of California at Los Angeles; JD, University of California at Berkeley) is associate professor in the Departments of Chicana/o Studies and Asian American Studies at the University of California at Los Angeles. He is the author of the award-winning <em>The Chinese in Mexico, 1882-1940</em>, <em>Jesus for Revolutionaries: An Introduction to Race, Social Justice, and Christianity</em>, and <em>Mixed Race Student Politics</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42007edf